<template>
  <div id="transcc_new_NewFooter">
    <!-- 账号信息 -->

    <div class="transcc_new_NewFooter_mainbox">
      <!-- <div class="transcc_new_NewFooter_trade">
        <div class="changebtns">
          <div
            class="changebtn"
            :class="tradeBtnType === 'jy' ? 'selected' : ''"
            @click="changeTradeBtn('jy')"
          >
            交易
          </div>
          <div
            class="changebtn"
            :class="tradeBtnType === 'js' ? 'selected' : ''"
            @click="changeTradeBtn('js')"
          >
            交收
          </div>
        </div>
        <div v-if="tradeBtnType === 'jy'" class="functionBtns">
          <div
            v-for="(item, i) in functionBtns"
            :key="`functionBtns_btn_${i}`"
            class="functionBtns_btn"
            :class="functionBtnsType === i ? 'selected' : ''"
            @click="changeFunctionBtn(i)"
          >
            <div class="functionBtns_btn_box" :style="item.style">
              {{ item.name }}
            </div>
            <div class="functionBtns_btn_b_line"></div>
          </div>
        </div>
      </div> -->
      <!-- 交易 -->
      <div
        v-if="tradeBtnType === 'jy'"
        style="display:flex;width:100%;background: #000000;"
        
      >
        <RealTimeTrans
          v-if="(functionBtnsType == 0 || functionBtnsType == 1) && !FAST_TradeView_Right"
          class="transcc_new_NewFooter_tradef"
          :buy-or-sell="buyOrSell"
          :btn-type="functionBtnsType"
        >
        <template #btn>
          <!-- 交易&报表切换控制按钮 左-->
          <div v-if="!FAST_TradeView_Right" class="transcc_new_NewFooter_trade" style="margin-right: 9px;margin-left: 0;">
            <div class="trade_btn trade_btn_left" :class="{'selectLeftBtn redBgc':functionBtnsType===0}" @click="changeFunctionBtn(0)">买入</div>
            <div class="trade_btn trade_btn_left trade_sell_btn" :class="{'selectLeftBtn greenBgc':functionBtnsType===1}" @click="changeFunctionBtn(1)">卖出</div>
          </div>
          <!-- 交易&报表切换控制按钮 -->
        </template>
        </RealTimeTrans>
        <!-- 报表 -->
        <div
          v-if="
            functionBtnsType == 0 ||
              functionBtnsType == 1
          "
          class="transcc_new_NewFooter_tabs"
        >
          <div class="transcc_new_NewFooter_header">
              <div class="transcc_new_NewFooter_header_l">
                <div class="header_l_item">
                  <div class="header_l_item_name">登录账号</div>
                  <div class="header_l_item_v" style="color:'rgba(255, 255, 255, 0.8)'">
                    {{
                      sessionInfoGetter.tel
                        ? sessionInfoGetter.tel.slice(0, 3) +
                          '****' +
                          sessionInfoGetter.tel.slice(7, 11)
                        : '--'
                    }}
                  </div>
                </div>
                <div class="header_l_item">
                  <div class="header_l_item_name">可用资金</div>
                  <div
                    v-if="isShowHAvilibleMargin"
                    class="header_l_item_v"
                    style="color:#d94066"
                  >
                    {{ h_avilibleMargin ? Number(h_avilibleMargin).toFixed(2) : '--'
                    }}<span style="color:#979797">元</span>&nbsp;&nbsp;
                    <img
                      src="../../../assets/images/openEye.svg"
                      alt=""
                      style="vertical-align: middle;cursor: pointer;"
                      @click="showHAvilibleMargin(0)"
                    >
                  </div>
                  <div v-else class="header_l_item_v" style="color:#D94066">
                    **** <span style="color:#979797">元</span>&nbsp;&nbsp;
                    <img
                      src="../../../assets/images/closeEye.svg"
                      alt=""
                      style="vertical-align: middle;cursor: pointer;"
                      @click="showHAvilibleMargin(1)"
                    >
                  </div>
                </div>
                <div class="header_l_item">
                  <div class="header_l_item_name">风险率</div>
                  <!-- 大于 预警值 正常色  大于强平 小于预警值 黄色 小于等于强平 红色   -->
                  <div
                    class="header_l_item_v"
                    :style="
                      RiskRightGetter && RiskRightGetter.risk
                        ? RiskRightGetter.risk > warnValue
                          ? 'color:#979797'
                          : RiskRightGetter.risk <= forceCloseValue
                            ? 'color:red'
                            : 'color:yellow'
                        : 'color:979797'
                    "
                  >
                    {{
                      RiskRightGetter && RiskRightGetter.risk
                        ? RiskRightGetter.risk
                        : '0'
                    }}%
                  </div>
                </div>
                <div class="header_l_item">
                  <div class="header_l_item_name">实时货值变化</div>
                  <div
                    class="header_l_item_v"
                    :style="
                      holdPlSumGetter&&holdPlSumGetter.currentHoldPl&&holdPlSumGetter.currentHoldPl > 0
                        ? 'color:#D94066'
                        : holdPlSumGetter.currentHoldPl < 0
                          ? 'color:#41b37d'
                          : '#ffffff'
                    "
                  >
                    {{ holdPlSumGetter.currentHoldPl }}<span style="color:#979797">元</span>
                  </div>
                </div>
                <div class="header_l_item">
                  <div class="header_l_item_name">货值变化</div>
                  <div
                    class="header_l_item_v"
                    :style="
                      holdPlSumGetter&&holdPlSumGetter.holdPl&&holdPlSumGetter.holdPl > 0
                        ? 'color:#D94066'
                        : holdPlSumGetter.holdPl < 0
                          ? 'color:#41b37d'
                          : '#ffffff'
                    "
                  >
                    {{ holdPlSumGetter.holdPl }}<span style="color:#979797">元</span>
                  </div>
                </div>
              </div>
              <div
                v-if="!isSupInfo && RiskRightGetter &&
                  RiskRightGetter.risk &&
                  RiskRightGetter.risk <= warnValue"
                class="transcc_new_NewFooter_header_waring"
              >
                <img src="./img/waring.png" style="margin-right: 10px;">
                <!-- 改成小于等于代为转让值+10% -->
                <span v-if="RiskRightGetter.risk <= forceCloseValue + 10" style="color: red">您当前的风险率已低于{{ forceCloseValue + 10 }}%，请及时追加履约金。</span>
                <!-- <span v-if="RiskRightGetter.risk <= 80" style="color: red">您当前的风险率已低于80%，请及时追加履约金。</span> -->
                <span v-else>您当前的风险率已低于{{ warnValue }}%，请及时追加履约金。</span>
              </div>
              <div
                v-if="isSupInfo && RiskRightGetter &&
                  RiskRightGetter.risk &&
                  RiskRightGetter.risk >= 100"
                class=" transcc_new_NewFooter_header_waring1"
              >
                <img src="./img/waring.png">
                <!-- 修改文字时 修改 transcc_new_NewFooter_header_waring1 span的宽度 和动画的 left-->
                <span v-if="RiskRightGetter.risk == 100">尊敬的交易商您好，当前您的可用资金为负且风险率等于100%，请及时追加可用资金或适当减少持有合同订单数量，否则风险率触及（大于等于）300%时平台有权代为转让/托管；届时，交易中心不再另行通知，请您及时关注账号；</span>
                <span v-else>尊敬的交易商您好，当前您的可用资金为负且风险率大于100%，请及时追加可用资金或适当减少持有合同订单数量，否则风险率触及（大于等于）300%时平台有权代为转让/托管；届时，交易中心不再另行通知，请您及时关注账号；</span>
              </div>
              <!-- <div class="transcc_new_NewFooter_header_r">
                <div class="btn" @click="setDialogShow">设置</div>
              </div> -->
          </div>
          <div class="transcc_new_NewFooter_tabs_head">
            <div class="head_l">
              <div
                class="head_l_btns"
                :class="currentTab == 1 ? 's' : ''"
                @click="currentTab = 1"
              >
                持仓明细
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 2 ? 's' : ''"
                @click="currentTab = 2"
              >
                持仓汇总
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 3 ? 's' : ''"
                @click="currentTab = 3"
              >
                当前委托
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 4 ? 's' : ''"
                @click="currentTab = 4"
              >
                历史委托
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 5 ? 's' : ''"
                @click="currentTab = 5"
              >
                当前成交
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 6 ? 's' : ''"
                @click="currentTab = 6"
              >
                历史成交
              </div>
              <div
                class="head_l_btns"
                :class="currentTab == 7 ? 's' : ''"
                @click="currentTab = 7"
              >
                资金
              </div>
            </div>
            <div v-if="currentTab == 3" class="head_r">
              <div class="head_l_btns" @click="cancleOrder()">撤单</div>
              <div class="head_l_btns" @click="cancleTypeOrder(2)">撤买</div>
              <div class="head_l_btns" @click="cancleTypeOrder(3)">撤卖</div>
              <div class="head_l_btns " @click="cancleTypeOrder(4)">撤最后一笔</div>
              <div v-if="hasYMOrder" class="head_l_btns" @click="cancleTypeOrder(5)">撤预埋单</div>
              <div class="head_l_btns" @click="cancleTypeOrder(1)">全撤</div>
            </div>
            <div v-if="currentTab == 1 || currentTab == 2" class="head_r">
              <div v-if="APP_WINNY_NAME !== '楚云农商'" class="head_l_btns" :disabled="disableYS" @click="stopProfitLoss(1)">撤止盈</div>
              <div v-if="APP_WINNY_NAME !== '楚云农商'" class="head_l_btns" :disabled="disableYS" @click="stopProfitLoss(2)">撤止损</div>
              <div class="head_l_btns" :disabled="disableYS" @click="stopProfitLoss(3)">全撤</div>
            </div>
            <div v-if="currentTab == 7" class="head_r">
              <div class="head_l_btns" :disabled="isReferAsset" @click="reshferAssest()">刷新</div>
            </div>
          </div>
          <div class="table_out_box">
            <div class="table_inside_box" :class="currentTab==6?'last_table_inside_box':''">
              <div v-if="currentTab == 1" class="newWidth">
                <holdDetail :is-spot-s="isSpotS" />
              </div>
              <div v-if="currentTab == 2" class="newWidth">
                <unsettledAuery />
              </div>
              <div v-if="currentTab == 3" class="newWidth">
                <allSettleQuery :is-cancle="isCancle" :is-corder="isCorder" @changIsCanle="changIsCanle" @changeYMOrderType="changeYMOrderType" />
              </div>
              <div v-if="currentTab == 4" class="newWidth">
                <inventoryDetails />
              </div>
              <div v-if="currentTab == 5" class="newWidth">
                <recordQuery />
              </div>
              <div v-if="currentTab == 6" class="newWidth">
                <cancleQuery />
              </div>
              <div v-if="currentTab == 7" class="newWidth">
                <!-- 资金 -->
                <MyAssets ref="assetInfo" />
              </div>
            </div>
          </div>
        </div>
        <RealTimeTrans
          v-if="(functionBtnsType == 0 || functionBtnsType == 1) && FAST_TradeView_Right"
          class="transcc_new_NewFooter_tradef"
          :buy-or-sell="buyOrSell"
          :btn-type="functionBtnsType"
        >
        <template #btn>
              <!-- 交易&报表切换控制按钮 右-->
            <div v-if="FAST_TradeView_Right" class="transcc_new_NewFooter_trade">
              <div class="trade_btn" :class="{'selectLeftBtn redBgc':functionBtnsType===0}" @click="changeFunctionBtn(0)">买入</div>
              <div class="trade_btn trade_sell_btn" :class="{'selectLeftBtn greenBgc':functionBtnsType===1}" @click="changeFunctionBtn(1)">卖出</div>
            </div>
        </template>
        </RealTimeTrans>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      class="newPopup"
    >
      <span>{{ cancleTip }}?</span>
      <span slot="footer" class="dialog-footer">

        <el-button class="surexBtn" type="primary" @click="revokeConfirm">确定</el-button>
        <el-button class="canclexBtn" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="newPopup"
      :visible.sync="dialogVisible1"
      :show-close="false"
    >
      <span>{{ cancleTip }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="surexBtn" type="primary" @click="stopPloss">确定</el-button>
        <el-button class="canclexBtn" @click="dialogVisible1 = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 设置弹窗 -->
    <setDialog
      ref="setDialog"
      title="交易设置"
    />
    <!-- 交易弹窗 buyOrSell:买卖方向 functionBtnsType:0 买 1 卖 -->
    <ScaleReal
      v-if="isOrderScale"
      ref="realtimetransScale"
      @closeScaleReal="closeScaleReal"
    />
  </div>
</template>
<script>
/*global protocol http */
import allSettleQuery from './allSettleQuery'
import unsettledAuery from './unsettledAuery'
import recordQuery from './recordQuery'

import cancleQuery from './cancleQuery'
import holdDetail from './holdDetail'
import inventoryDetails from './inventoryDetails'
import RealTimeTrans from '../realtimetrans/RealTimeTrans.vue'
import ScaleReal from '../realtimetrans/scaleReal.vue'
import MyAssets from './tab/myAssetsNew.vue'
import setDialog from '../../../components/base/dialog/setDialog.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    holdDetail,
    allSettleQuery,
    unsettledAuery,
    recordQuery,
    cancleQuery,
    inventoryDetails,
    RealTimeTrans,
    ScaleReal,
    MyAssets,
    setDialog,
  
  },
  provide(){
    return {
      tradeView:()=>this.FAST_TradeView_Right
    }
  },
  data() {
    return {
      warnValue: (window.g.APP_WINNY_NAME === "神农购销" || window.g.APP_WINNY_NAME === "景瓷兴") ? 40 : 90, // 预警阈值
      forceCloseValue: (window.g.APP_WINNY_NAME === "神农购销" || window.g.APP_WINNY_NAME === "景瓷兴") ? 20 : 70, // 强平阈值
      isSupInfo: window.g.isSupInfo,
      isOrderScale: true, // 交易弹窗
      disableYS: false, // 止盈止损撤单按钮
      isCancle: false, // 当前委托撤单
      isCorder: false, // 撤单后重新请求data
      isSpotS: false, // 撤止盈止损按钮请求data
      cancleTip: '', // 撤单提示信息
      currentCancle: '', // 当前是什么撤单
      currentTab: 1,
      showWaring: true,
      tradeBtnType: 'jy', // 默认选中
      functionBtns: [
        { name: '买入商品', style: 'color: #FF0021;' },
        { name: '卖出商品', style: 'color: #00FF05;' }
      ],
      functionBtnsType: 0,
      settlementType: 0,
      tradeTypes: ['订立', '转让'],
      seelctTradeType: '订立',
      disable: false,
      time: null,
      dialogVisible1: false,
      isShowHAvilibleMargin: 1,
      selectItem: {},
      dialogVisible: false,
      isReapt: false,
      isReferAsset: false,
      hasYMOrder: false,
      // isXJ: window.g.APP_WINNY_NAME === '陇南北盐' || window.g.APP_WINNY_NAME === '贵州茶交数字化中心' || window.g.APP_WINNY_NAME === '硒交在线' || window.g.APP_WINNY_NAME === '西北商品' || window.g.APP_WINNY_NAME === '贵茶云购',
      FAST_TradeView_Right: !!window.g.FAST_SET.FAST_TradeView_Right,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'h_avilibleMargin',
      'topCLickNum',
      'holdPlSumGetter',
      'RiskRightGetter',
      'buyclick',
      'sellclick'
    ]),
    buyOrSell() {
      let style = 'buy'
      if (this.functionBtnsType == 0) {
        style = 'buy'
      } else if (this.functionBtnsType == 1) {
        style = 'sell'
      }
      return style
    }
  },
  watch: {
    // 当点击top触发更新 弹出弹窗
    topCLickNum() {
      this.realtimetransScaleShow()
    },
    // 切换买
    buyclick() {
      this.changeFunctionBtn(0)
    },
    // 切换卖
    sellclick() {
      this.changeFunctionBtn(1)
    }
  },
  mounted() {
    this.assetImg = this.openAseet
    this.findTqRisk()
    // 添加监听机制,处理交易组件(RealTimeTrans)
    window.addEventListener('TradViewChange', this.reView)
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time)
      this.time = null
    }
    window.removeEventListener('TradViewChange', this.reView)
  },
  methods: {
    // 查询风险阈值 isAudit  pOro
    findTqRisk() {
      protocol.param_findTqRisk.param.page = 0
      protocol.param_findTqRisk.param.size = 999999999
      http.getRes(protocol.param_findTqRisk).then(response => {
      const { code, message, value } = response.data
      this.isResponse = true
        if (code === 0 || code === '0') {
          const riskInfo = value.content.find(item => {
            return item.firmType == 1
          })
          if (riskInfo) {
            this.warnValue = riskInfo.warnValue
            this.forceCloseValue = riskInfo.forceCloseValue
          }
        } else {
          this.$message(message)
        }
      })
    },
    /**
     * 设置交易组件位置
     */
    reView() {
      console.log('触发显示修改', window.g.FAST_SET.FAST_TradeView_Right)
      if (window.g.FAST_SET.FAST_TradeView_Right) {
        this.FAST_TradeView_Right = true
      } else {
        this.FAST_TradeView_Right = false
      }
    },
    changeYMOrderType(i) {
      this.hasYMOrder = i
    },
    // 显示设置弹窗
    setDialogShow() {
      this.$refs.setDialog.showDialog()
    },
    // 显示交易弹窗
    realtimetransScaleShow() {
      this.$refs.realtimetransScale.showDialog()
    },
    // 隐藏弹窗回显
    closeScaleReal() {
      this.isOrderScale = false
      setTimeout(() => {
        this.isOrderScale = true
      }, 100)
    },

    showHAvilibleMargin(i) {
      this.isShowHAvilibleMargin = i
    },
    revokeConfirm() {
      if (this.currentCancle == '所有单') {
        this.cancleAllOrder()
      } else if (this.currentCancle == '买单') {
        this.cancleDir('B')
      } else if (this.currentCancle == '卖单') {
        this.cancleDir('S')
      } else if (this.currentCancle == '最后一笔') {
        this.cancleZh()
      } else if (this.currentCancle == '预埋单') {
        this.cancleYM()
      }
    },
    stopPloss() {
      if (this.currentCancle == '撤止盈') {
        this.cancleYS('Y')
      } else if (this.currentCancle == '撤止损') {
        this.cancleYS('S')
      } else if (this.currentCancle == '全撤') {
        this.cancleYS('YS')
      }
    },
    // 撤止盈
    cancleYS(type) {
      this.disableYS = true
      // "stopLossPrice": 0, "stopProfitPrice":
      let param = {}
      switch (type) {
        case 'Y': // 止盈
          param = {
            stopProfitPrice: 0
          }
          break
        case 'S': // 止损
          param = {
            stopLossPrice: 0
          }
          break
        case 'YS':
          param = {
            stopProfitPrice: 0,
            stopLossPrice: 0
          }
          break
        default:
          break
      }
      protocol.param_setStopPrice.param = param
      http.postFront1(protocol.param_setStopPrice).then(response => {
        this.disableYS = false
        if (response.data) {
          this.$message(response.data.message)
          if (response.data && response.data.code == '0') {
            this.isSpotS = true
            setTimeout(() => {
              this.dialogVisible1 = false
              this.isSpotS = false
            }, 0)
          }
        }
      })
    },
    cancleOrder() {
      // 用于当前委托的撤单
      if (this.currentTab == 3) {
        this.isCancle = true
      }
    },
    // 对接撤止盈/撤止损/全撤(止盈止损) 东
    stopProfitLoss(num) {
      if (num == 1) {
        this.currentCancle = '撤止盈'
        this.cancleTip = '您确定要撤销止盈单吗'
        this.dialogVisible1 = true
      } else if (num == 2) {
        this.currentCancle = '撤止损'
        this.cancleTip = '您确定要撤销止损单吗'
        this.dialogVisible1 = true
      } else if (num == 3) {
        this.currentCancle = '全撤'
        this.cancleTip = '您确定要撤销所有止盈止损单吗'
        this.dialogVisible1 = true
      }
    },
    reshferAssest() {
      if (this.isReferAsset) {
        return
      } else {
        this.isReferAsset = true
      }
      this.$refs.assetInfo.queryTradeClosepl()
      setTimeout(() => {
        this.isReferAsset = false
      }, 1000)
    },
    cancleTypeOrder(num) {
      // 用于当前委托的所有撤单
      if (this.currentTab == 3 || this.currentTab == 4) {
        if (num == 1) {
          this.currentCancle = '所有单'
          this.cancleTip = '您确定要撤销所有委托单吗'
        } else if (num == 2) {
          this.currentCancle = '买单'
          this.cancleTip = '您确定要撤销所有买委托吗'
        } else if (num == 3) {
          this.currentCancle = '卖单'
          this.cancleTip = '您确定要撤销所有卖委托吗'
        } else if (num == 4) {
          this.currentCancle = '最后一笔'
          this.cancleTip = '您确定要撤销最后一笔委托吗'
        } else if (num == 5) {
          if (protocol.cancelYM.data.orderIdList.length === 0) {
            this.$message('未选委托单')
            return
          }
          this.currentCancle = '预埋单'
          this.cancleTip = '您确定要撤销预埋单吗'
        }
        // 撤单时弹出提示确认对话框
        if (window.g.FAST_SET.FAST_revoke_Dialog) {
          this.dialogVisible = true
        } else {
          this.revokeConfirm()
        }
      }
    },
    cancleAllOrder() {
      // 用于当前委托的所有撤单
      if (this.isReapt) {
        return
      } else {
        this.isReapt = true
      }

      http.gPost(protocol.cancelAll).then(response => {
        if (response.data) {
          this.isReapt = false
          if (response.data && response.data.code == '0') {
            this.isCorder = true
            setTimeout(() => {
              this.isCorder = false
            }, 1000)
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.value)
            }
            this.createPlayer()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
        }
      })
      this.dialogVisible = false
    },
    // 提示音播放
    createPlayer() {
      if (window.g.FAST_SET.FAST_Ordersuccess_Playsound) {
        const audio = new Audio(require('../../../assets/voice/1.mp3'))
        audio.play()
      }
    },
    cancleDir(dir) {
      // 用于撤买单
      if (this.isReapt) {
        return
      } else {
        this.isReapt = true
      }
      protocol.cancelFlag.data.bsFlag = dir
      http.gPost(protocol.cancelFlag).then(response => {
        if (response.data) {
          this.isReapt = false
          if (response.data && response.data.code == '0') {
            this.isCorder = true
            setTimeout(() => {
              this.isCorder = false
            }, 1000)
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.value)
            }
            this.createPlayer()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
        }
      })
      this.dialogVisible = false
    },
    cancleZh() {
      // 用于最后一笔
      if (this.isReapt) {
        return
      } else {
        this.isReapt = true
      }
      http.gPost(protocol.cancelLastOrder).then(response => {
        this.isReapt = false
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.isCorder = true
            setTimeout(() => {
              this.isCorder = false
            }, 1000)
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.message)
            }
            this.createPlayer()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
        }
      })
      this.dialogVisible = false
    },
    cancleYM() {
      // 用于撤预埋单
      if (this.isReapt) {
        return
      } else {
        this.isReapt = true
      }
      http.gPost(protocol.cancelYM).then(response => {
        this.isReapt = false
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.isCorder = true
            setTimeout(() => {
              this.isCorder = false
            }, 1000)
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.message)
            }
            this.createPlayer()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
        }
      })
      this.dialogVisible = false
    },
    changIsCanle() {
      this.isCancle = false
    },
    changeTradeBtn(i) {
      this.tradeBtnType = i
    },
    changeFunctionBtn(i) {
      this.functionBtnsType = i
    },
    changeSettleBtn(i) {
      this.settlementType = i
    }
  }
}
</script>
<style lang="scss" scoped>
//el-pagination
::v-deep .pagination_style{
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
::v-deep .el-input__inner:focus{
  border-color: #dfdfdf;
}
::v-deep .pagination_style  .el-pagination__total, ::v-deep .pagination_style  .el-pagination__jump{
  color: #E8E8E8 !important;
  font-size: 12px;
}
::v-deep .pagination_style .el-pager li{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 12px;
    color: #E8E8E8;
    text-align: center;
}
::v-deep .pagination_style .el-pager li.active{
  font-weight: 800;
}
::v-deep .pagination_style .el-pagination__editor.el-input .el-input__inner {
  width: 40px;
  height: 18px;
  font-size: 12px;
  color: #e8e8e8;
  text-align: center;
  text-indent: 0;
  background: transparent;
}
::v-deep .pagination_style button:hover{
    color: #dfdfdf !important;
    font-weight: 600;
}
::v-deep .pagination_style .btn-next,::v-deep .pagination_style .btn-prev{
  color: #e8e8e8;
}

//el-table
::v-deep .table_style{
  .el-table__body-wrapper{
    overflow: auto;
  }
  .el-table__empty-text{
    line-height: 0;
  }
}
</style>
<style  lang="scss">
.transcc_search {
  height: 35px;
  padding-left: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
  .el-input__inner{
    color:#979797
  }
  .itemSearch{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 30px 12px 0;
    .title{
      margin-right: 8px;
      width:60px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #979797;
    }
    .searchSelect{
      width:158px;
      height: 26px;
      background-color: transparent;
    }
    .decTitle{
      width: 44px;
    }
  }
  .actionSearch {
    margin-left: 30px;
  }
}
#transcc_new_NewFooter {
  background: #141517;
  width: 100%;
  height: 100%;
  .btn {
    cursor: pointer;
  }
  .newWidth {
    width: 100%;
    min-width: 880px;
    // width:calc(100% - 181px);
  }
  .transcc_new_NewFooter_tabs_goods_name{
    display: flex;
    font-family: Source Han Sans SC;
    font-weight: 500;
    font-size: 14px;
    color: #DFDFDF;
    padding-left: 40px;
    border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
    height: 35px;
    .title{
       margin: 9px 40px 9px 0;
    }
    ul{
      display: flex;
      li{
        cursor: pointer;
         margin: 9px 40px 9px 0;
        // margin-left: 40px;
        color: #979797;
      }
    }
  }

  .transcc_new_NewFooter_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 35px;
    height: 35px;
    border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
    padding-left: 36px;
    position: relative;
    .transcc_new_NewFooter_header_l {
      display: flex;
      align-items: center;
      .header_l_item {
        margin: 9px 42px 9px 0;
        display: flex;
        align-items: center;
        .header_l_item_name {
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #979797;
          line-height: 14px;
        }
        .header_l_item_v {
          height: 22px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          font-size: 14px;
          color: #979797;
          line-height: 22px;
          margin:0 9px;
        }
      }
    }
    .transcc_new_NewFooter_header_r {
      display: flex;
      .btn {
        // width: 32px;
        // height: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0486fe;
        line-height: 32px;
        padding: 0 20px;
        background: transparent;
      }
    }
    @keyframes shake {
      0%,
      100% {
        transform: translate(-3px, 0px);
      }
      50% {
        transform: translate(200px, 0);
      }
    }
    .transcc_new_NewFooter_header_waring {
      position: absolute;
      left: 790px;
      top: 5px;
      width: 520px;
      height: 22px;
      background: #000000;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #cee600;
      line-height: 20px;
      // 动画
      animation: shake 8s; // 设置jello的动画播放时长为1秒。
      animation-iteration-count: infinite;
      span {
        color: #cee600;
      }
    }
    @keyframes shake1 {
      0%{
        left: 31px;
      }
      100% {
        left: -2029.7px;
      }
    }
    .transcc_new_NewFooter_header_waring1 {
      margin-left: 20px;
      // width: 490px;
      flex: 1;
      position: relative;
      height: 22px;
      background: #000000;
      display: flex;
      align-items: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #cee600;
      line-height: 20px;
      overflow: hidden;
      img {
      padding-right: 10px;
      background: #000000;
      z-index: 99;
      }
      span {
        position: absolute;
        left: 31px;
        width: 2060.7px;
        height: 22px;
        display: inline-block;
        color: #cee600;
        z-index: 0;
        animation: shake1 50s; // 设置jello的动画播放时长为1秒。
        animation-iteration-count: infinite;
        animation-timing-function: linear
      }
    }
  }
  .transcc_new_NewFooter_mainbox {
    display: flex;
    // height: 322px;
    height: 100%;
    overflow: hidden;
    .transcc_new_NewFooter_trade{
      margin-left: 9px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      //   cursor: pointer;
      .trade_btn{
        box-sizing: border-box;
        cursor: pointer;
        width: 30px;
        height: 70px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #EEEEEE;
        line-height: 23px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 12px;
        border: 1px solid #989898;
        // margin-top: 4px;
      }
      .trade_btn ~ .trade_btn{
        margin-top: 10px;
      }
      .selectLeftBtn{
        border: none;
        color: #FFFFFF;
        background: #D94066;
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 14px;
        color: #EEEEEE;
        line-height: 23px;
      }
      .greenBgc{
        background: #41B37D;
      }
    
    }
    .transcc_new_NewFooter_tradef {
      box-sizing: border-box;
      padding: 0 10px 0 10px;
      display: flex;
      flex-direction: column;
      width: 271px;
      // height: calc(100% - 15px);  // 放大k线之前的
      height: 399px;
      margin:  0 3px;
      .head {
        display: flex;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #464c74;
        .buyBtn {
          flex: 1;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #fff;
        }
        .closeBtn {
          flex: 1;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0486fe;
        }
      }
      .trade {
        .tradeBSBtn {
          cursor: pointer;
          width: 100%;
          height: 100%;
          background: #E6F1FC;
          border-radius: 4px;
          color: #0486FE;
          text-align: center;
          line-height: 34px;
        }
        .tradeBSBtn.buybtn{
          background: #0486FE;
          color: #E6F1FC;
        }
        .optimizeInfoBox{ // 可优化数量
          display: flex;
          justify-content: flex-start;
          height: 20px;
          width: 100%;
          div{
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 20px;
          }
          div~div{
            color: #41b37d;
          }
        }
      }
    }
    .transcc_new_NewFooter_tabs {
      flex: 1;
      min-width:1092px;
      background: #161719;
      .transcc_new_NewFooter_tabs_head {
        // min-width: 1200px;
        display: flex;
        // justify-content: space-between;
        justify-content: flex-start;
        height: 35px;
        padding-left: 36px;
        border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
        // width: 1127px;
        .head_l,
        .head_r {
          display: flex;
          align-items: center;
        }
        .head_l_btns {
          position: relative;
          display: flex;
          align-items: center;
          height: 14px;
          // font-size: 16px;
          // font-family: PingFangSC-Semibold, PingFang SC;
          // font-weight: 600;
          // color: #b3b3b3;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #979797;
          line-height: 14px;
          padding: 11px 0 ;
          margin-right: 40px;
          cursor: pointer;
          &::before,&::after{
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 0%;
            height: 2px;
            background-color: #ffffff;
            transition: all .2s linear;
          }
        }
        .s {
          color: #d7d7d7;
          font-weight: 500;
          &::before{
            width: 50%;
            left: 0;
          }
          &::after{
            width: 50%;
          }
        }
        .head_r {
        
          .head_l_btns {
            height: 14px;
            border-radius: 4px;
            border: 1px solid #979797;
            padding: 6px 13px;
            margin-right: 8px;
            color: #979797;
            &::before{
              content: '';
              width: 0;
            }
          }
        }
      }
      .transcc_new_NewFooter_tabs_mid {
        // margin-top: 16px;
        min-width: 770px;
      }
      .transcc_new_NewFooter_tabs_tabBox {
        width: 100%;
        min-width: 770px;
 
        .transcc_new_NewFooter_tabs_tabBox_head {
          width: 100%;
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 60px;
          .tab_head_item {
            display: flex;
            align-items: center;
            height: 14px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.6);
            line-height: 14px;
          }
        }
        .borderline {
          width: 100%;
          height: 1px;
          background: linear-gradient(
            45deg,
            rgba(94, 101, 146, 0.4) 0%,
            #464c74 53%,
            rgba(48, 53, 89, 0.4) 100%
          );
        }
      }
    }
  }
  .table_out_box {
    width: 100%;
    height: calc(100% - 44px);
    // height:100%;
    // overflow: scroll;
    .table_inside_box {
      min-width: 800px;
    }
    .last_table_inside_box{
      min-width:880px;
    }
  }
  /deep/ .el-input__inner {
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
    font-weight: 400;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    border-radius: 4px;
    border: 1px solid rgba(220, 223, 230, 0.3);
  }
  /deep/ .el-radio-group .el-radio-button__inner {
    background: transparent;
    width: 111px;
    border-color: rgba(220, 223, 230, 0.3);
    color: rgba(255, 255, 255, 0.4);
  }
  // 选中
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: transparent;
    color: #0486fe;
    border-color: rgba(220, 223, 230, 0.3);
  }

  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-slider {
    width: 100%;
  }
  /deep/ .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    // 文字属性
    height: 34px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.4);
  }
  /deep/.el-button {
    font-weight: bold;
  }
  /deep/ .el-radio-group {
    display: flex;
    /deep/.el-radio-button {
      flex: auto;
    }
  }
  // .selectLeftBtn{
  //   // background: #510000;
  //   box-shadow: 0 4px 8px 0 rgba(255,255,255,0.50);
  //   // border-radius: 6px 6px 0 6px;
  // }
}
</style>
<style lang="scss">
#transcc_new_NewFooter .transcc_new_NewFooter_tabs_tabBox {
  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #2b2b2b;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #2b2b2b;
    // border-bottom:none;
  }
  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #2b2b2b;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #2b2b2b;
  }
  .el-table td,
  .el-table th,
  .el-table .el-table__cell {
    padding: 4px 0;
  }
  .el-table .cell {
    line-height: 15px;
  }
  .red-row {
    color: #D94066;
  }
  .green-row {
    color: #41B37D !important;
  }
  .white-row{
    color:#fff;
  }
  .yellow-row {
    font-weight: normal;
    color: #cee600;
  }
  .spotS{
    display: inline-block;
    padding: 3px 14px;
    // background: #fff;
    border-radius: 20px;
    cursor: pointer;
    color: #fff;
    border: 2px solid #404040;
  }
  .fw {
    font-weight: normal;
  }
  .fr {
    display: inline-block;
    text-align: right;
    width: 100%;
  }
  .fc {
    color: #fff;
  }
  .el-table__header-wrapper .cell {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.6);
  }
  // .el-table__body-wrapper{
  //   height:148px!important;
  // }
  .el-table__footer-wrapper .cell{
    font-weight: normal !important;
  }
  .el-table__footer-wrapper td:nth-child(n + 5) .cell {
    // text-align: right !important;
    overflow-x:auto;
    white-space: nowrap;
    text-overflow: clip;
  }
}
</style>
<style>
#transcc_new_NewFooter .el-table__footer-wrapper tbody td.el-table__cell {
  background: #141517 !important;
}
/* #transcc_new_NewFooter .el-table__footer-wrapper {
  margin-top:1px;
} */
#transcc_new_NewFooter .el-table__footer-wrapper td.el-table__cell {
  border-top: 1px solid #2b2b2b;
  font-weight: bold;
}

#transcc_new_NewFooter .el-table__footer-wrapper tbody td,
#transcc_new_NewFooter .el-table__header-wrapper tbody td,
#transcc_new_NewFooter .el-table,
#transcc_new_NewFooter .el-table th,
#transcc_new_NewFooter .el-table__expanded-cell,
#transcc_new_NewFooter .el-pagination button:disabled,
#transcc_new_NewFooter .el-pager li,
#transcc_new_NewFooter .el-pagination .btn-next,
#transcc_new_NewFooter#transcc_new_NewFooter .el-pagination .btn-prev {
  background-color: #141517;
}

#transcc_new_NewFooter .table_out_box::-webkit-scrollbar-thumb{
  border-radius: 4px;
}
#transcc_new_NewFooter ::-webkit-scrollbar-thumb{
  background-color: #1b1e28;
}
#transcc_new_NewFooter .table_out_box::-webkit-scrollbar{
 height: 10px;
}
#transcc_new_NewFooter .el-table .sort-caret.ascending {top: -3px;}
#transcc_new_NewFooter .el-table .sort-caret.descending { bottom: 0px;  }
#transcc_new_NewFooter .el-table .caret-wrapper { height: 18px;}
#transcc_new_NewFooter .el-table__header-wrapper .cell{
  line-height: 18px;
}
</style>
